import type { ReactNode } from 'react'
import * as Mtds from '@mattilsynet/design/react'
import type { PlanLegislation } from '../../types/types'
import { LegislationReferences } from '../legislation-references/LegislationReferences'
import styles from './LegislationEntry.module.css'

type LegislationEntryProps = {
  entry: Pick<PlanLegislation, 'legislation' | 'selectedParts'>
  actions?: ReactNode
  metadata?: ReactNode
}

/** Shared read-only layout; callers own surfaces, permissions and mutations. */
export function LegislationEntry({
  entry,
  actions,
  metadata
}: Readonly<LegislationEntryProps>) {
  return (
    <Mtds.Grid data-gap='2' className={styles.entry}>
      <Mtds.Flex data-justify='space-between' data-align='start' data-nowrap>
        <Mtds.Grid data-gap='1' data-self='full' className={styles.title}>
          <Mtds.Heading as='h3' data-size='2xs'>
            {entry.legislation.shortTitle}
          </Mtds.Heading>
          <Mtds.Muted>{entry.legislation.code}</Mtds.Muted>
        </Mtds.Grid>
        {actions}
      </Mtds.Flex>
      {metadata}
      <LegislationReferences entry={entry} />
    </Mtds.Grid>
  )
}
